###
Pattern

Holds a pattern of notes. Used as 'stamps', a person can copy a
selection of notes and paint them as a group onto the staff.

Status: Needs review
###

Model from ./model.civet

Pattern := (I={}, self=new Model(I)) ->
  defaults I,
    notes: []

  self.attrAccessor "notes"

  return self

export default Pattern
